export enum ImageFileTypes {
    jpg = '.jpg',
    jpeg = '.jpeg',
    png = '.png',
    gif = '.gif',
}
